export default __webpack_public_path__ + "static/media/gonioscopyImage.c51782d0.svg";